import { Component, OnInit } from '@angular/core';
import {
    style,
    animate,
    transition,
    trigger,
    query as q,
    stagger
} from '@angular/animations';
export function query(s, a, o = {optional: true}) {
    return q(s, a, o);
}

import { ActivatedRoute } from '@angular/router';

import {
    AuthService,
    LocalStorageService,
    RouteSegmentService
} from '../../core/upgraded-providers';

import { ConfirmService } from '../../ui.module';

const TUTORIAL_STEPS = [
    { name: 'Game UI and basic scripting' },
    { name: 'Upgrading controller' },
    { name: 'Building structures' },
    { name: 'Auto-spawning creeps' },
    { name: 'Defending your room' },
    // { name: 'Go to the world' }
];

const listTransition = trigger('list', [
    transition('* => true', [ // each time the binding value changes
        query('.tutorial-step', style({ opacity: 0 })),
        query('.tutorial-step', [
            stagger('150ms', [
                animate('0.2s 150ms ease-in-out', style({ opacity: 1 }))
            ])
        ])
    ])
]);

@Component({
    selector: 'app-tutorial-steps',
    templateUrl: './tutorial-steps.component.pug',
    styleUrls: ['./tutorial-steps.component.less'],
    animations: [
        listTransition
    ]
})
export class TutorialStepsComponent implements OnInit {

    public steps = [];
    public _isAnimate = false;
    public isAnimateTutorial = false;

    constructor(
        private _authService: AuthService,
        private _confirm: ConfirmService,
        private _localStorage: LocalStorageService,
        private _routeSegmentService: RouteSegmentService,
        private _route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.steps = TUTORIAL_STEPS;
    }

    public animateTutorial(val) {
        this.isAnimateTutorial = val;
    }

    public isAnimate() {
        return this.isAnimateTutorial;
    }

    public isTutorialDone(index) {
        if (index === 6) {
            return this.isAllTutorialDone();
        }

        const tutorialDone = this._localStorage.get('tutorialSectionsDone', {});
        return !!tutorialDone[index];
    }

    public isAllTutorialDone() {
        return [1, 2, 3, 4, 5].every((i) => this.isTutorialDone(i));
    }

    public goToSection(index) {
        if (index === 6) {
            return this.goToWorld();
        }

        if (this.isTutorialDone(index)) {
            this._confirm.show({ data: {
                message: `
                    This will remove your existing code from the "tutorial-${index}" branch.
                    Do you want to restart this tutorial section?
                `
            }})
                .then(() => this._goToSection(index));
        } else {
            this._goToSection(index);
        }
    }

    private _goToSection(index) {
        console.log('go to section');
        const tutorialDone = this._localStorage.get('tutorialSectionsDone', {});
        tutorialDone[index] = false;
        this._localStorage.put('tutorialSectionsDone', tutorialDone);

        let hash = '!' + this._routeSegmentService.getSegmentUrl('top.sim-tutorial', {section: index});
        if (!!this._route.snapshot.queryParams.anonymous) {
            hash += '?anonymous=1';
        }
        location.hash = hash;
    }

    public goToWorld() {
        if (!this._authService.required()) {
            return;
        }

        if (!this._authService.Me.cpu) {
            location.hash = '!' + this._routeSegmentService.getSegmentUrl('top.order');
            return;
        }

        location.hash = '!' + this._routeSegmentService.getSegmentUrl('top.game-world-map', {shard: 'shard0'});
    }
}
